import { useEffect, useState } from 'react'
import settings from 'popups/Settings'

interface FormatSettings {
  timeFormat: string
  dateFormat: string
}

/**
 * 날짜 및 시간 포맷 설정 관리 훅
 * 모든 TodoListItem 컴포넌트에서 공유되는 포맷 설정을 중앙에서 관리
 * @returns {Object} 시간 포맷과 날짜 포맷
 */
export const useFormatSettings = (): FormatSettings => {
  const [timeFormat, setTimeFormat] = useState<string>(
    () => settings.getValue('general').timeFormat,
  )
  const [dateFormat, setDateFormat] = useState<string>(
    () => settings.getValue('general').dateFormat,
  )

  useEffect(() => {
    const handleSettingsChange = (): void => {
      const newTimeFormat: string = settings.getValue('general').timeFormat
      const newDateFormat: string = settings.getValue('general').dateFormat

      if (newTimeFormat !== timeFormat) {
        setTimeFormat(newTimeFormat)
      }

      if (newDateFormat !== dateFormat) {
        setDateFormat(newDateFormat)
      }
    }

    const unsubscribe = settings.getStore().subscribe(handleSettingsChange)

    return () => {
      unsubscribe()
    }
  }, [timeFormat, dateFormat])

  return {
    timeFormat,
    dateFormat,
  }
}
